import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ClusterState } from 'src/app/cluster/cluster.state';


@Injectable({
  providedIn: 'root'
})

export class AssetInfoViewService {

  private regionsAndSections = new BehaviorSubject<any>([]);
  castRegionName = this.regionsAndSections.asObservable()

  private currentRegionIds = new BehaviorSubject<any>([]);
  castCurrentRegionIds = this.currentRegionIds.asObservable()

  private regionName = new BehaviorSubject<string>('Default');
  private sectionName = new BehaviorSubject<string>('Default');
  private regionId = new BehaviorSubject<string>("");
  private sectionId = new BehaviorSubject<string>("");

  currentRegionName = this.regionName.asObservable();
  currentSectionName = this.sectionName.asObservable();
  currentRegionId = this.regionId.asObservable();
  currentSectionId = this.sectionId.asObservable();

  setRegionAndSections(currentRegion: any[]) {
    this.regionsAndSections.next(currentRegion)
  }

  setCurrentRegionIds(currentRegionIds: any[]) {
    const normalizedRegionIds = this.normalizeRegionIds(currentRegionIds)
    const currentIds = this.normalizeRegionIds(this.currentRegionIds.getValue())

    if (this.areSameRegionIds(currentIds, normalizedRegionIds)) {
      return
    }

    this.currentRegionIds.next(normalizedRegionIds)
    this.clusterState.resetState();
  }

  private normalizeRegionIds(regionIds: any[]): string[] {
    if (!Array.isArray(regionIds)) {
      return []
    }

    return [...new Set(regionIds.filter(Boolean))]
  }

  private areSameRegionIds(previous: string[], next: string[]): boolean {
    return previous.length === next.length && previous.every((value, index) => value === next[index])
  }

  constructor(private clusterState: ClusterState) {
  }

  // Clear all BehaviorSubjects
  destroy() {
    this.regionsAndSections.complete();
    this.currentRegionIds.complete();
    this.regionName.complete();
    this.sectionName.complete();
    this.regionId.complete();
    this.sectionId.complete();
  }

  resetState() {
    this.regionsAndSections.next([]);
    this.currentRegionIds.next([]);
    this.regionName.next('Default');
    this.sectionName.next('Default');
    this.regionId.next('');
    this.sectionId.next('');
  }

  exportRegionName(name: string) {
    this.regionName.next(name);
  }

  exportSectionName(name: string) {
    this.sectionName.next(name);
  }

  exportRegionId(regionId: string) {
    this.regionId.next(regionId);
  }

  exportSectionId(sectionId: string) {
    this.sectionId.next(sectionId);
  }
}
